/* Little Scholars Co. - motion engine
   Scroll reveals, count-ups and parallax. Hero scene cycling lives in
   sections/lsc-animated-hero.liquid so it re-inits on section reload. */
(function () {
  var d = document;
  d.documentElement.classList.add('lsc-js');

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = null;
  var pxEls = [];
  var ticking = false;

  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  /* ---------- count-up ---------- */
  function countUp(scope) {
    var nodes = [];
    if (scope.hasAttribute && scope.hasAttribute('data-lsc-count')) nodes.push(scope);
    if (scope.querySelectorAll) each(scope.querySelectorAll('[data-lsc-count]'), function (n) { nodes.push(n); });
    each(nodes, function (el) {
      if (el.getAttribute('data-lsc-counted')) return;
      el.setAttribute('data-lsc-counted', '1');
      var end = parseFloat(el.getAttribute('data-lsc-count')) || 0;
      var dec = parseInt(el.getAttribute('data-lsc-decimals') || '0', 10);
      var dur = parseInt(el.getAttribute('data-lsc-duration') || '1500', 10);
      if (reduce) { el.textContent = end.toFixed(dec); return; }
      var t0 = null;
      function step(t) {
        if (t0 === null) t0 = t;
        var p = Math.min((t - t0) / dur, 1);
        var e = 1 - Math.pow(1 - p, 3);
        el.textContent = (end * e).toFixed(dec);
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    });
  }

  function reveal(el) { el.classList.add('lsc-in'); countUp(el); }

  function revealAll() {
    each(d.querySelectorAll('[data-lsc-reveal],[data-lsc-section],[data-lsc-count]'), reveal);
  }

  /* ---------- observe ---------- */
  function tag() {
    if (!io) return;
    var main = d.querySelector('main[data-template="index"]');
    if (main) {
      each(main.children, function (sec) {
        if (!sec.classList || !sec.classList.contains('shopify-section')) return;
        if (sec.hasAttribute('data-lsc-section')) return;
        if (sec.querySelector('[data-lsc-hero]')) return;   /* hero animates itself */
        if (sec.querySelector('[data-lsc-self]')) return;   /* custom sections stagger internally */
        sec.setAttribute('data-lsc-section', '');
        io.observe(sec);
      });
    }
    each(d.querySelectorAll('[data-lsc-reveal]'), function (el) {
      if (el.classList.contains('lsc-in') || el.getAttribute('data-lsc-obs')) return;
      el.setAttribute('data-lsc-obs', '1');
      io.observe(el);
    });
  }

  /* ---------- parallax ---------- */
  function collectParallax() {
    pxEls = [];
    each(d.querySelectorAll('[data-lsc-parallax]'), function (el) {
      el.classList.add('lsc-px');
      pxEls.push(el);
    });
  }

  function onScroll() {
    if (reduce || !pxEls.length || ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var vh = window.innerHeight;
      each(pxEls, function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -300 || r.top > vh + 300) return;
        var f = parseFloat(el.getAttribute('data-lsc-parallax')) || 0.12;
        var mid = r.top + r.height / 2 - vh / 2;
        el.style.setProperty('--lsc-py', (-mid * f).toFixed(1) + 'px');
      });
      ticking = false;
    });
  }

  /* ---------- boot ---------- */
  function init() {
    if (reduce || !('IntersectionObserver' in window)) { revealAll(); return; }
    io = new IntersectionObserver(function (entries) {
      each(entries, function (e) {
        if (!e.isIntersecting) return;
        reveal(e.target);
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });
    tag();
    collectParallax();
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  }

  d.addEventListener('shopify:section:load', function () { tag(); collectParallax(); onScroll(); });

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init);
  else init();
})();
